<template>
<div>
    <v-card>
       <v-toolbar color="grey lighten-3" dense height="30">
        <v-toolbar-title>Invoice Details</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-title>Rohail</v-toolbar-title>       
      </v-toolbar>
    
      <v-container style="padding-bottom:5px;">
      
        <v-dialog
          v-model="invoicesDialog"
          max-width="850"
        >
          <v-card style="height: 350px;">        
            <invoice-panel :selected-customer-id="selectedCustomer && selectedCustomer.id"></invoice-panel>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                text
                @click="invoicesDialog = false"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="paymentsDialog"
          max-width="850"
        >
          <v-card style="height: 350px;">        
            <finance-panel :selected-customer-id="selectedCustomer && selectedCustomer.id"></finance-panel>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                text
                @click="paymentsDialog = false"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Refund Modal Dialog -->
        <v-dialog
          v-model="refundDialog"
          max-width="500"
          persistent
        >
          <v-card>
            <v-toolbar color="primary" dark dense flat>
              <v-toolbar-title class="subtitle-1 font-weight-bold">
                Process Refund - Invoice #{{ selectedInvoice && selectedInvoice.id }}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="refundDialog = false" :disabled="refundLoading">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>

            <v-card-text class="pt-4 pb-1">
              <v-alert v-if="refundError" type="error" dense dismissible @input="refundError = ''">
                {{ refundError }}
              </v-alert>

              <div class="mb-3">
                <div><strong>Customer:</strong> {{ (selectedCustomer && selectedCustomer.name) || 'N/A' }}</div>
                <div><strong>Invoice Total:</strong> £{{ invoiceTotalFormatted }}</div>
              </div>

              <v-divider class="mb-3"></v-divider>

              <v-text-field
                v-model="refundForm.amount"
                type="number"
                step="0.01"
                label="Refund Amount *"
                prefix="£"
                dense
                outlined
                required
              ></v-text-field>

              <v-select
                v-model="refundForm.paymentMethod"
                :items="['Cash', 'Card', 'Bank Deposit', 'Cheque']"
                label="Refund Method *"
                dense
                outlined
              ></v-select>

              <v-text-field
                v-model="refundForm.description"
                label="Description / Reason"
                placeholder="e.g. Passenger ticket refund"
                dense
                outlined
              ></v-text-field>

              <div v-if="supplier && supplier.id" class="mt-1">
                <v-checkbox
                  v-model="refundForm.includeSupplier"
                  :label="`Also record refund from Supplier (${supplier.name || 'Supplier'})`"
                  dense
                  hide-details
                  class="mb-2"
                ></v-checkbox>
                <v-text-field
                  v-if="refundForm.includeSupplier"
                  v-model="refundForm.supplierAmount"
                  type="number"
                  step="0.01"
                  label="Supplier Refund Amount"
                  prefix="£"
                  dense
                  outlined
                ></v-text-field>
              </div>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions class="pa-3">
              <v-spacer></v-spacer>
              <v-btn text @click="refundDialog = false" :disabled="refundLoading">
                Cancel
              </v-btn>
              <v-btn color="error" :loading="refundLoading" @click="submitRefund">
                Confirm Refund
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Main Layout (Original Structure) -->
        <div style="align-content: space-between; display: flex;">
          <div class="col-md-4">
            <v-text-field
              placeholder="New"
              dense
              label="Invoice Number"
              :value="id"
              key="id"
              v-on:keyup.enter="changeInvoice"
            ></v-text-field>
    
            <v-menu
              v-model="datemenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  dense            
                  label="Invoice Date"            
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  :value="formattedInvoiceDate"
                ></v-text-field>
              </template>
              <v-date-picker          
                :value="formattedInvoiceDate"
                @change="v => { createdAt = v; datemenu = false; }"
                @input="createdAt = false"
              ></v-date-picker>
            </v-menu>

            <v-text-field
              dense
              label="Locator"
              :value="locator"
              v-on:keyup.enter="changeLocator"
              @change="v => locator = v"
            ></v-text-field>

            <v-text-field
              dense
              label="Vendor Locator"
              :value="vendLoc"
              v-on:keyup.enter="changeVendorLocator"
              @change="v => vendLoc = v"
            ></v-text-field>
            
            <v-text-field
              dense
              label="GDS"
              :value="gds"
              @change="v => gds = v"
            ></v-text-field>

            <v-select
              :loading="isLoading"
              :search-input.sync="searchSupplier"
              @change="supplierSelected"
              :value="supplier"
              dense
              label="Supplier"
              :items="allSuppliers" 
              item-text="name"
              item-value="id"
            ></v-select>
          </div>         

          <div class="col-md-5" style="margin-left: auto;">
            <v-text-field
              dense
              label="ATOL Charges"
              :value="aToL"
              @change="updateAToL"
            ></v-text-field>

            <v-text-field
              dense
              label="Discount"
              :value="discount"
              @change="updateDiscount"
            ></v-text-field>      

            <input
              type="checkbox"
              name="check"
              class="post"
              :checked="isPosted"
              @change="posted()"
            />   
            Is Posted 
            <v-btn
              class="refund-btn"
              v-show="selectedInvoice && selectedInvoice.id"
              @click="openRefundModal"
            >
              Refund
            </v-btn>

            <div style="display: flex; align-items: center; justify-content: space-between; margin-top: 6px;">
              <v-btn color="primary" text @click="invoicesDialog = true" style="padding: 0 4px; min-width: 70px;"> 
                INVOICES              
              </v-btn>
              <v-btn color="primary" text @click="paymentsDialog = true" style="padding: 0 4px; min-width: 70px;"> 
                PAYMENTS
              </v-btn>
            </div>
            
            <div class="labels-container">
              <div class="row-label">
                <label class="md-body-1 bold-label" for="cid">Credit Limit</label>
                <label class="bold-value">{{ selectedCustomer && selectedCustomer.creditLimit }}</label>              
              </div>
              <div class="row-label">
                <label class="md-body-1 bold-label" for="cid">Current Balance </label>
                <label class="bold-value">{{ balance }}</label>              
              </div>
              <div class="row-label">
                <label class="md-body-1 bold-label" for="cid">Projected Balance </label>
                <label class="bold-value">{{ projectedBalance }}</label>              
              </div>
            </div>

          </div>
        </div>
      </v-container>
    </v-card>

    <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="4000" top right>
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">Close</v-btn>
      </template>
    </v-snackbar>
</div>
</template>

<script>
  import { validationMixin } from 'vuelidate'
  import { mapActions, mapState } from 'vuex'  
  import { createHelpers } from 'vuex-map-fields';
  import { EventBus } from './../../eventbus/event-bus.js';  
  import Invoices from './../ledger/Invoices';
  import Finance from './../ledger/Finance';
  import { invoiceService } from './../../services/invoice.sevice.js';

  const { mapFields: mapInvoiceFields } = createHelpers({
    getterType: 'invoice/getField',
    mutationType: 'invoice/updateField',
  }); 

  export default {
    name: 'invoice-detail-panel',    
    components: {
      'invoice-panel': Invoices,
      'finance-panel': Finance,
    },
    computed: {        
      ...mapInvoiceFields([
        'selectedInvoice.locator',
        'selectedInvoice.createdAt',
        'selectedInvoice.id',
        'selectedInvoice.vendLoc',
        'selectedInvoice.supplier',
        'selectedInvoice.gds',
        'selectedInvoice.total',
        'selectedInvoice.discount',
        'selectedInvoice.aToL',
        'selectedInvoice.isPosted'
      ]),
      ...mapState('customers', ['selectedCustomer']),
      ...mapState('invoice', ['selectedInvoice', 'selectedSupplier']),

      formattedInvoiceDate: function () {
        if (!this.createdAt) return '';
        const d = String(this.createdAt);
        return d.length >= 10 ? d.slice(0, 10) : d;
      },

      supplierName: function () {
        return this.supplier != null ? this.supplier.name : "";
      },

      supplier: function () {        
        if (this.selectedInvoice != null && this.selectedInvoice.supplier != null) {
          return this.selectedInvoice.supplier;
        } else {
          return this.selectedSupplier;
        }          
      },

      balance: function () {
        if (this.selectedCustomer) {
          return this.selectedCustomer.balance ? this.selectedCustomer.balance : 0;
        }
        return 0;
      },

      invoiceTotalFormatted: function () {
        if (this.selectedInvoice) {
          if (this.selectedInvoice.total) return parseFloat(this.selectedInvoice.total).toFixed(2);
          if (this.selectedInvoice.passengers && this.selectedInvoice.passengers.length > 0) {
            const sum = this.selectedInvoice.passengers.reduce((s, p) => s + parseFloat(p.gross || 0), 0);
            return sum.toFixed(2);
          }
        }
        return '0.00';
      }
    },                    
    mixins: [validationMixin],
    data: () => ({ 
      newSupplier: {
        id: 'New',
        name: null,
      },
      gdsValues: [],
      datemenu: false,
      invoicesDialog: false,
      paymentsDialog: false,

      refundDialog: false,
      refundLoading: false,
      refundError: '',
      refundForm: {
        amount: '',
        paymentMethod: 'Cash',
        description: '',
        includeSupplier: false,
        supplierAmount: ''
      },

      snackbar: false,
      snackbarText: '',
      snackbarColor: 'success',
      
      projectedBalance: 0,
      allSuppliers: [],
      searchSupplier: null,
      supplierDict: {},  
         
      isLoading: false,
    }),
    created () {
      let self = this
      this.getAll().then(selectedCustomer => {
        self.allSuppliers = selectedCustomer.filter(customer => customer.type == "Supplier");
        
        self.allSuppliers.forEach(element => {
          self.supplierDict[element.id] = element
        });
         
        self.allSuppliers = JSON.parse(JSON.stringify(self.allSuppliers))
        let firstSupplier;
        for (let supp = 0; supp < self.allSuppliers.length; supp++) {
          let supplier = self.allSuppliers[supp];
          if (supplier.name == "BSP") {
            firstSupplier = supplier
            self.allSuppliers.splice(supp, 1);
          }
        }

        if (firstSupplier) {
          self.allSuppliers.unshift(firstSupplier);
          self.updateSelectedSupplier(self.allSuppliers[0])
        }
      })
    },
    mounted(){        
      let self = this
      EventBus.$on('projectedBalanceCalculated', function (projectedBalance) {
        self.projectedBalance = projectedBalance.toFixed(2)
      });
    },
    watch:{
      searchSupplier (searchTerm) {          
        if (!searchTerm || searchTerm.length < 3) {
          console.log(this.cities);
        } else {
          const term = searchTerm.toLowerCase()
          let filterd = this.allSuppliers.filter(({ name }) => name.toLowerCase().includes(term))
          this.suppliers = filterd
        }        
      },
    },
    methods: {      
      ...mapActions('invoice', ['getInvoice', 'updateDiscount', 'updateAToL', 'getLocator', 'getVendorLocator']),      
      ...mapActions('invoice', ['updateSelectedSupplier']),
      ...mapActions('customers', ['getAll']),

      changeInvoice (event) {        
        let invoiceId = event.target.value;
        this.getInvoice(invoiceId)
      },
      changeLocator(event) {
        console.log("changeLocator")
        let locatorId = event.target.value;
        this.getLocator(locatorId)
      },
      changeVendorLocator(event) {
        let vendorLocatorId = event.target.value;
        this.getVendorLocator(vendorLocatorId)
      },   
      supplierSelected (supplierId) {
        let supp = this.supplierDict[supplierId]
        console.log(supp)
        this.updateSelectedSupplier(JSON.parse(JSON.stringify(supp)));
      },
      posted () {
        this.isPosted = !this.isPosted;
      },

      openRefundModal () {
        if (!this.selectedCustomer || !this.selectedCustomer.id) {
          this.snackbarText = 'Please select a customer or load an invoice first.'
          this.snackbarColor = 'warning'
          this.snackbar = true
          return
        }

        let initialAmount = this.invoiceTotalFormatted !== '0.00' ? this.invoiceTotalFormatted : ''
        
        this.refundForm = {
          amount: initialAmount,
          paymentMethod: 'Cash',
          description: `Refund for Invoice #${this.selectedInvoice.id || ''}`,
          includeSupplier: false,
          supplierAmount: ''
        }
        this.refundError = ''
        this.refundDialog = true
      },

      async submitRefund () {
        if (!this.refundForm.amount || parseFloat(this.refundForm.amount) <= 0) {
          this.refundError = 'Please enter a valid refund amount.'
          return
        }

        this.refundLoading = true
        this.refundError = ''

        try {
          const payload = {
            customerId: this.selectedCustomer.id,
            invoiceId: (this.selectedInvoice && this.selectedInvoice.id) || null,
            supplierId: this.refundForm.includeSupplier && this.supplier ? this.supplier.id : null,
            amount: parseFloat(this.refundForm.amount),
            supplierAmount: this.refundForm.includeSupplier && this.refundForm.supplierAmount ? parseFloat(this.refundForm.supplierAmount) : 0,
            paymentMethod: this.refundForm.paymentMethod,
            description: this.refundForm.description || `Refund for Invoice #${this.selectedInvoice.id || ''}`
          }

          const response = await invoiceService.processRefund(payload)
          
          if (response && response.newBalance !== undefined && this.selectedCustomer) {
            this.selectedCustomer.balance = response.newBalance
          }

          this.snackbarText = `Refund of £${parseFloat(this.refundForm.amount).toFixed(2)} processed successfully!`
          this.snackbarColor = 'success'
          this.snackbar = true
          this.refundDialog = false
        } catch (err) {
          this.refundError = typeof err === 'string' ? err : (err.message || 'Failed to process refund')
        } finally {
          this.refundLoading = false
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .v-text-field {         
    margin-bottom:-1px;
    margin-top:-1px;
  }
  
  .v-text-field.md-focused label, .v-text-field.md-has-value label {         
    top:5px;
  }

  .labels-container {         
    margin-top:40px;
  }
  .row-label {
    align-content: space-between;
    display: flex;
    margin-bottom: 10px;
  }
  .bold-label {
    font-weight: 500;
    font-size: 17px;
  }
  .bold-value {
    margin-left:auto;
    padding-left:2px;
    font-weight: 500;
    font-size: 17px;
    color:#606060
  }
  
  .post {
    width:15px;
    height:15px;
  }

  .refund-btn {
    margin-left:20px;
  }
</style>